let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("64OGY")).then(() => parcelRequire('i1aQI'));